module.exports = __webpack_public_path__ + "static/media/marge.e9ec71ea.jpg";